import { Col, Container, Row } from "react-bootstrap";
import { useMemo } from "react";
import { NAVIGATION_MENU, NavigationLink } from "../layout/AppSidebar";
import { useAuth } from "../contexts/auth";
import { DashboardCard } from "../Components/DashboardCard";
import "./Dashboard.css";

const SECTION_LABELS: Record<string, string> = {
  general: "Generale",
  gestione: "Gestione",
  libreria: "Libreria",
  parametri: "Parametri",
};

const SECTION_ORDER: string[] = ["general", "libreria", "gestione", "parametri"];

export default function Dashboard() {
  const { loggedUser } = useAuth();

  const sections = useMemo(() => {
    const visible = NAVIGATION_MENU.filter((link) => !link.hide).filter(
      (link) => +loggedUser?.role! <= link.level
    );
    const grouped = new Map<string, NavigationLink[]>();
    visible.forEach((link) => {
      const key = link.group ?? "general";
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key)!.push(link);
    });
    return SECTION_ORDER.filter((k) => grouped.has(k)).map((k) => ({
      key: k,
      label: SECTION_LABELS[k] ?? k,
      links: grouped.get(k)!,
    }));
  }, [loggedUser]);

  const firstName = loggedUser?.nome?.trim();

  return (
    <Container className="dashboard-page justify-content-center align-items-start">
      <header className="dashboard-masthead">
        <div className="dashboard-masthead-text">
          <span className="dashboard-masthead-brand">Coaching Master</span>
          <h1 className="dashboard-greeting">
            {firstName ? `Ciao, ${firstName}` : "La tua dashboard"}
          </h1>
          <p className="dashboard-masthead-sub">
            Costruisci, gestisci e monitora le tue programmazioni.
          </p>
        </div>
        <img
          className="dashboard-masthead-logo"
          src={require("../assets/img/LOGO COACHING MASTER - CLAUDIO MESSINA LOGO VETTORIALE_Tavola disegno 1.png")}
          alt="Logo Coaching Master"
        />
      </header>

      {sections.map((section) => (
        <section key={section.key} className="dashboard-section">
          <header className="dashboard-section-header">
            <span className="dashboard-section-tick" aria-hidden="true" />
            <h2 className="dashboard-section-title">{section.label}</h2>
            <span className="dashboard-section-count">{section.links.length}</span>
          </header>
          <Row className="justify-content-start">
            {section.links.map((link) => (
              <Col key={link.key} sm={12} md={6} lg={4} xl={3} className="mb-3">
                <DashboardCard
                  title={link.title}
                  icon={link.icon}
                  link={link.url}
                />
              </Col>
            ))}
          </Row>
        </section>
      ))}
    </Container>
  );
}
